export default {
  common: {
    orderNo: '订单号',
    customerName: '客户名称',
    productName: '产品型号',
    packageType: '封装形式',
    lotNo: '印章号',
    orderDate: '下单日期',
    sendNum: '可发货数量',
    waitNum: '待测数量',
    reset: '重置',
    query: '查询',
    import: '导入',
    export: '导出',
    chipName: '芯片名称',
    processType: '加工项目',
    expressageNo: '快递单号',
    expressageType: '运输方式',
    expressage: '快递公司',
    boxNo: '箱号',
    storePosition: '库位',
    count: '数量',
    operate: '操作',
    detail: '详情',
    status: '状态',
    new: '新建',
    cancel: '取消',
    save: '保存',
    update: '更改',
    importDate: '导入时间',
    caseNo: '盒号',
    contact: '联系人',
    contactPhone: '联系电话',
    address: '地址',
    sure: '确定',
    comment: '备注',
    back: '返回',
    delete: '删除',
    add: '新增',
    prevStep: '上一步',
    nextStep: '下一步',
    submit: '提交',
    productOrderNo: '发货单号',
    productOrder: '发货单',
    passCount: '合格品数',
    failCount: '坏品数',
    expectedDeliveryNumber: '期待发货数',
    deliveryNumber: '发货数',
    deliveredNumber: '已发货数',
    newlyAdded: '新增',
    edit: '编辑',
    finish: '完成',
    complete: '结束',
    cancelFinish: '取消结束',
    success: '成功',
    createTime: '创建时间',
    operateTime: '操作时间',
    createSuccess: '创建成功',
    deleteSuccess: '删除成功',
    updateSuccess: '修改成功',
    addSuccess: '添加成功',
    saveSuccess: '保存成功',
    submitSuccess: '提交成功',
    uploadSuccess: '上传成功',
    uploadFailure: '上传失败',
    associateSuccess: '关联成功',
    scanSuccess: '扫描成功',
    disassociateSuccess: '取消关联成功',
    sizeNotExceed2M: '文件大小不能超过2M',
    empty: '无',
    priorityLevel: '紧急度',
    isMixed: '是否混编',
    startDevicen: '起始DeviceNO',
    endDevicen: '加工完成DeviceNO',
    partNo: '标签上打印的PARTNO',
    yes: '是',
    no: '否',
    cancelEntrySuccess: '撤销入库成功',
    deliverySuccess: '出库成功',
    cancelDeliverySuccess: '取消出库成功',
    expectCount: '发货数量',
    subNo: '子批号',
    entryTime: '入库时间',
    storePassCount: '在库合格品数',
    storeFailCount: '在库坏品数',
    associate: '关联',
    number: '编号',
    orderTime: '下单时间',
    binLevel: '档位',
    returnTicket: '回签单',
    print: '打印',
    weight: '重量',
    stylePreview: '样式预览',
    contractNo: '合同号',
    grossWeight: '毛重',
    netWeight: '净重',
    labelType: '标签类型',
    reprint: '重新打印',
    supplierCode: '供应商代码',
    keyword: '关键字',
    labelName: '标签名称',
    productName2: '品名',
    deviceCategory: '设备类别',
    deviceName: '设备名称',
    deviceModel: '设备型号',
    deviceNumber: '设备编号',
    productionDate: '生产日期',
    installDate: '安装日期',
    supportProducts: '支持产品',
    dailyEnergy: '日产能',
    softwareVersion: '软件版本',
    other: '其它',
    rowTestDevice: '行测试设备',
    columnTestDevice: '列测试设备',
    normal: '正常',
    closedBeta: '内测',
    forSale: '待售',
    scrapped: '报废',
    component: '组件',
    testReport: '测试报告',
    deliveryReport: '发货报告',
    deliveryCheckReport: '发货确认报告',
    componentName: '组件名称',
    componentModel: '组件型号',
    componentNumber: '组件编号',
    dailyProductionCapacity: '日产能',
    label: '标签',
    printLabel: '打印标签',
    deviceHistory: '设备历史',
    componentHistory: '组件历史',
    check: '查看',
    updateTime: '更新时间',
    shipmentNumber: '发货单号',
    upload: '上传',
    device: '设备',
    selectDevice: '选择设备',
    selectComponent: '选择组件',
    deliveryDevice: '发货设备',
    exportDeviceList: '导出设备列表',
    exportComponentList: '导出组件列表',
    revise: '修改',
    associatedDevice: '关联的设备',
    selected: '已选',
    under: '下面',
    aTotalOf: '共有',
    unit: '单位',
    deliveryList: '发货清单',
    componentSerialNo: '组件串号',
    waferNo: '片号',
    waferCount: '片数',
    moduleNo: '模块编号',
    moduleNoQrCode: '二维码内容',
    category: '类别',
    identification: '标识',
  },
  login: {
    title: 'ERP 系统',
    logIn: '登录',
    username: '用户名',
    password: '密码',
    pleaseEnterCorrectName: '请输入正确的用户名',
    pleaseEnterCorrectPwd: '密码不能为空',
    loginSuccess: '登录成功',
    exitTheAccountAndLoggedIn: '已有用户登录该账户，是否退出该账号已登录用户?',
    theCurrentUserLogsInElsewhere: '当前用户在其他地方登录',
  },
  remindInfo: {
    warning: '提示',
    confirm: '确定',
    cancel: '取消',
  },
  header: {
    title: '项目后台管理系统',
    username: '您好！',
    logOut: '退出',
  },
  incomingOrder: {
    incoCount: '已收料数',
    outputCount: '已领料数',
    finishCount: '成品入库数',
    sendCount: '已发货数',
    expectOverTime: '预计完工时间',
    newOrders: '新建订单',
    orderDetail: '订单详情',
    essentialInformation: '基本信息',
    orderDetails: '订单详情',
    priorityLevel: '紧急度',
    expectIncomingDate: '预期到料日期',
    expectFinishDate: '期望完工日期',
    expectOverDate: '预期完工日期',
    startDevicen: '起始DeviceNO',
    endDevicen: '完成DeviceNO',
    binLevel: '档位',
    isMixed: '混编',
    attachment: '添加附件',
    upload: '上传文件',
    customerNameCanNotBeEmpty: '客户名称不能为空',
    productNameCanNotBeEmpty: '产品型号不能为空',
    factoryCanNotBeEmpty: '封装厂家不能为空',
    processTypeCanNotBeEmpty: '加工项目不能为空',
    incomingOrderNoCanNotBeEmpty: '订单号不能为空',
    priorityLevelCanNotBeEmpty: '紧急度不能为空',
    orderDateCanNotBeEmpty: '下单日期不能为空',
    expectIncomingDateCanNotBeEmpty: '预期日期不能为空',
    contactCanNotBeEmpty: '联系人不能为空',
    expectFinishDateCanNotBeEmpty: '期待完工日期不能为空',
    expectOverDateCanNotBeEmpty: '预期完工日期不能为空',
    startDevicenCanNotBeEmpty: '起始DeviceNO不能为空',
    endDevicenCanNotBeEmpty: '完成DeviceNO不能为空',
    binLevelCanNotBeEmpty: '档位不能为空',
    isMixedCanNotBeEmpty: '混编不能为空',
    createSuccess: '创建成功',
    updateSuccess: '修改成功',
    thisActionWillDeleteTheProductsInThisOrder: '此操作将删除该订单中的产品, 是否继续?',
    thisActionWillDeleteThisOrder: '此操作将删除该订单, 是否继续?',
    thisActionWillFinishThisOrder: '此操作将结束该订单, 是否继续?',
    thisActionWillUnFinishThisOrder: '此操作将取消结束该订单, 是否继续?',
    manyTypesOfOutsourcedOrderNumberInImportedData: '导入数据中存在多种外包单号',
    anOrderCanOnlyHaveAtMostOneAttachment: '一个订单只能有一个附件',
    orderDateCanNotBeLaterThanExpectedArrivalDate: '下单日期不能晚于预期到料日期',
    expectedArrivalDateCanNotBeEarlierThanOrderDate: '预期到料日期不能早于下单日期',
    expectedCompletionDateCanNotBeEarlierThanOrderDate: '期待完工日期不能早于下单日期',
  },
  incomeStorage: {
    operaterName: '收料者',
    operaterTime: '收料时间',
    manyTypesOfProductNamesInImportedData: '导入数据中存在多种产品型号',
    manyTypesOfChipNamesInImportedData: '导入数据中存在多种芯片名称',
    manyTypesOfPackageTypesInImportedData: '导入数据中存在多种封装形式',
    thereCanOnlyBeOneLotNoInABox: '一个箱子中只能存在一个印章号',
    importedFileFormatIncorrect: '文件格式不支持',
    importedDataFormatIncorrect: '导入数据格式不对',
    importedDataIsEmpty: '导入数据为空',
    importSuccess: '导入成功',
    incomingImport: '来料导入',
    explain: '说明',
    import: '导入',
    importInfo: '',
    example: '示例',
    selectFile: '选取文件',
    importDate: '导入时间',
    updateAt: '最新编辑时间',
    editBox: '编辑箱子',
    boxInfo: '箱子信息',
    caseInfo: '盒子信息',
    thisActionWillDeleteTheCase: '此操作将删除该盒子, 是否继续?',
    thisActionWillCancelEntryTheBox: '此操作将撤销该箱子入库, 是否继续?',
    thisActionWillDeliveryTheBox: '此操作将该箱子出库, 是否继续?',
    thisActionWillCancelDeliveryTheBox: '此操作将撤销该箱子出库, 是否继续?',
    deleteSuccess: '删除成功',
    updateSuccess: '修改成功',
    addSuccess: '添加成功',
    addCase: '添加盒子',
    editCase: '编辑盒子',
  },
  deliveryGoods: {
    newOrder: '建单',
    sureBuild: '确定创建',
    selected: '已选',
    orders: '个订单',
    completeOrder: '发货建单已完成！',
    expressageTypeCanNotBeEmpty: '运输方式不能为空',
    expressageCanNotBeEmpty: '快递公司不能为空',
    expressageNoCanNotBeEmpty: '快递单号不能为空',
    selectCustomerInformation: '请选择客户信息',
    chooseExpressDelivery: '请选择快递',
    chooseBinLevel: '请选择档位',
    confirmedQuantity: '确认数量',
    expressReturnTicket: '快递回签单',
    saveXLSX: '保存 XLSX',
    saveAndPrint: '保存并打印',
    requestExpress: '要求快递公司',
    selectTheOrderFirst: '请先选择订单',
    deliveryNumberCanNotBeEmpty: '发货数不能为空',
    deliveryNumberMustMoreThan0: '发货数必须大于0',
    expectedDeliveryNumberCanNotBeEmpty: '期待发货数不能为空',
    expectedDeliveryNumberMustMoreThan0: '期待发货数必须大于0',
    theProductTypeOfTheSelectedOrderMustBeTheSame: '选择的订单的产品型号必须一样',
    buildSuccess: '创建成功',
    thisActionWillDeleteTheDeliveryOrder: '此操作将删除该发货单, 是否继续?',
    deliveryConfirmation: '发货确认',
    scanReturnTicket: '扫描回签单',
    returnTicketCanNotBeEmpty: '回签单不能为空',
    orderInfo: '订单信息',
    uploadReturnTicket: '上传快递回签单',
    deliveryInformation: '发货信息',
    customerInformation: '客户信息',
    expressInformation: '快递信息',
    productOrderNoCanNotBeEmpty: '发货单号不能为空',
    orderDateCanNotBeEmpty: '下单日期不能为空',
    orderTimeCanNotBeEmpty: '下单时间不能为空',
    associatedBoxes: '关联的箱子',
    statusCanNotBeEmpty: '状态不能为空',
    chipCountLessThanExpectCount: '关联的箱子芯片总数小于预期发货数，是否继续打印发货单?',
    binLevelArrCanNotBeEmpty: '档位不能为空',
  },
  incomeApp: {
    associatedBox: '关联箱子',
    scanningExpress: '扫描快递单',
    associatedBoxes: '已关联箱子',
    disassociatedBox: '取消关联',
    thisActionWillDisassociatedBox: '此操作将取消关联该箱子, 是否继续?',
    spread: '展开',
    retract: '收起',
  },
  factoryLabelPrint: {
    templateContentEditing: '模板内容编辑',
    processingOrderNo: '加工单号',
    purchaseOrderNo: '采购单号',
    materialNo: '物料编号',
    specificationNo: '规格型号',
    deliveryDate: '发货日期',
    storageDate: '入库时间',
    processingOrderNoCanNotBeEmpty: '加工单号不能为空',
    purchaseOrderNoCanNotBeEmpty: '采购单号不能为空',
    materialNoCanNotBeEmpty: '物料编号不能为空',
    specificationNoCanNotBeEmpty: '规格型号不能为空',
    deliveryDateCanNotBeEmpty: '发货日期不能为空',
    storageDateCanNotBeEmpty: '入库时间不能为空',
    productNameOrSpecification: '品名/规格',
    qiangLiBatchNo: '强力批号',
    productNameOrSpecificationCanNotBeEmpty: '品名/规格不能为空',
    orderNoCanNotBeEmpty: '订单号不能为空',
    qiangLiBatchNoCanNotBeEmpty: '强力批号不能为空',
    orderNumber: '订单编号',
    materialDescription: '物料描述',
    productionBatch: '生产批次',
    orderNumberCanNotBeEmpty: '订单编号不能为空',
    materialDescriptionCanNotBeEmpty: '物料描述不能为空',
    productionBatchCanNotBeEmpty: '生产批次不能为空',
    customerMaterialNo: '客户料号',
    customerMaterialNoCanNotBeEmpty: '客户料号不能为空',
    materialName: '物料名称',
    materialNameCanNotBeEmpty: '客物料名称不能为空',
    materialNameCanNotBeEmptyV2: '物料名称不能为空',
    partNoCanNotBeEmpty: 'P/N 不能为空',
    packageTypeCanNotBeEmpty: '封装形式不能为空',
    resultCanNotBeEmpty: '结果不能为空',
    markingCanNotBeEmpty: 'Marking不能为空',
    binLevelCanNotBeEmpty: '分档不能为空',
    materialNo2: '物料号',
    materialNo2CanNotBeEmpty: '物料号不能为空',
    customerModel: '客户型号',
    customerModelCanNotBeEmpty: '客户型号不能为空',
    productionDate: '生产日期',
    productionDateCanNotBeEmpty: '生产日期不能为空',
    qiangLiBatchNoFormatIncorrect: '强力批号格式错误',
    lotNoOfOutBox: '外箱批号',
    lotNoOfOutBoxCanNotBeEmpty: '外箱批号不能为空',
    moduleNoCanNotBeEmpty: '模块编号不能为空',
    moduleNoQrCodeCanNotBeEmpty: '二维码内容不能为空',
  },
  factoryLabelHistory: {
    labelEdit: '标签编辑',
    thisActionWillDeleteThisLabel: '此操作将删除该标签, 是否继续?',
  },
  errorPage404: {
    errorInfo: '请检查您输入的网址是否正确，或点击下面的按钮返回主页。',
    returnHome: '返回首页',
  },
  validate: {
    boxNoCanNotBeEmpty: '箱号不能为空',
    boxNoCanNotBePureNumbers: '箱号不能是纯数字',
    boxNoFormatIncorrect: '箱号格式错误',
    caseNoCanNotBeEmpty: '盒号不能为空',
    caseNoCanNotBePureNumbers: '盒号不能是纯数字',
    caseNoFormatIncorrect: '盒号格式错误',
    lotNoCanNotBeEmpty: '印章号不能为空',
    lotNoCanNotBePureNumbers: '印章号不能是纯数字',
    lotNoFormatIncorrect: '印章号格式错误',
    waferCountCanNotBeEmpty: '片数不能为空',
    waferCountMustBeAPositiveInteger: '片数必须是正整数',
    countCanNotBeEmpty: '数量不能为空',
    countMustBeAPositiveInteger: '数量必须是正整数',
    priceCanNotBeEmpty: '价格不能为空',
    priceMustBeANumberInteger: '价格必须是数值类型',
    priceHasAtMostTwoDecimalPlaces: '价格最多有两位小数',
    priceMustBeGreaterThan0: '价格必须大于0',
    contactPhoneCanNotBeEmpty: '联系电话为空',
    contactPhoneFormatIncorrect: '联系电话格式错误',
    productOrderNoCanNotBeEmpty: '发货单号不能为空',
    expressageNoCanNotBeEmpty: '快递单号不能为空',
    customerNameCanNotBeEmpty: '客户名称不能为空',
    productNameCanNotBeEmpty: '产品型号不能为空',
    factoryCanNotBeEmpty: '封装厂家不能为空',
    processTypeCanNotBeEmpty: '加工项目不能为空',
    incomingOrderNoCanNotBeEmpty: '订单号不能为空',
    incomingOrderNoFormatError: '订单号格式错误',
    priorityLevelCanNotBeEmpty: '紧急度不能为空',
    orderDateCanNotBeEmpty: '下单日期不能为空',
    expectIncomingDateCanNotBeEmpty: '预期日期不能为空',
    contactCanNotBeEmpty: '联系人不能为空',
    expectFinishDateCanNotBeEmpty: '期待完工日期不能为空',
    expectOverDateCanNotBeEmpty: '预期完工日期不能为空',
    startDevicenCanNotBeEmpty: '起始DeviceNO不能为空',
    endDevicenCanNotBeEmpty: 'DeviceNO不能为空',
    partNoCanNotBeEmpty: 'PARTNO不能为空',
    waferNoCanNotBeEmpty: '片号不能为空',
    propCanNotBeEmpty: 'prop不能为空',
    binLevelCanNotBeEmpty: '档位不能为空',
    isMixedCanNotBeEmpty: '混编不能为空',
    productDetailsCanNotBeEmpty: '订单详情不能为空',
    weightCanNotBeEmpty: '重量不能为空',
    weightMustBeANumber: '重量必须是数值型',
    weightMustBeAPositiveNumber: '重量必须是正数',
    contractNoCanNotBeEmpty: '合同号不能为空',
    grossWeightCanNotBeEmpty: '毛重不能为空',
    grossWeightMustBeANumber: '毛重必须是数值型',
    grossWeightMustBeAPositiveNumber: '毛重必须是正数',
    netWeightCanNotBeEmpty: '净重不能为空',
    netWeightMustBeANumber: '净重必须是数值型',
    netWeightMustBeAPositiveNumber: '净重必须是正数',
    trackingNoCanNotBeEmpty: 'Tracking No 不能为空',
    trackingNoCanNotBePureNumbers: 'Tracking No 不能是纯数字',
    trackingNoFormatIncorrect: 'Tracking No 格式错误',
    deviceCategoryCanNotBeEmpty: '设备类别不能为空',
    addressCanNotBeEmpty: '地址不能为空',
    deviceNameCanNotBeEmpty: '设备名称不能为空',
    deviceModelCanNotBeEmpty: '设备型号不能为空',
    deviceNumberCanNotBeEmpty: '设备编号不能为空',
    productionDateCanNotBeEmpty: '生产日期不能为空',
    statusCanNotBeEmpty: '状态不能为空',
    componentNameCanNotBeEmpty: '组件名称不能为空',
    componentModelCanNotBeEmpty: '组件型号不能为空',
    componentNumberCanNotBeEmpty: '组件编号不能为空',
  },
  priorityLevel: {
    urgent: '特急件',
    important: '急件',
    commonly: '普件',
  },
  device: {
    addNewDevice: '新建设备',
    addNewComponent: '新建组件',
    componentManagement: '组件管理',
    deviceDetail: '设备详情',
    componentDetail: '组件详情',
    aDeviceCanOnlyHaveAtMostOneTestReport: '一个设备只能有一份测试报告',
    aDeviceDeliveryCanOnlyHaveAtMostOneDeliveryReport: '一个设备发货订单只能有一份发货报告',
    aDeviceDeliveryCanOnlyHaveAtMostOneDeliveryCheckReport: '一个设备发货订单只能有一份发货确认报告',
    thisActionWillDeleteThisDevice: '此操作将删除该设备, 是否继续?',
    thisActionWillDeleteThisComponent: '此操作将删除该组件, 是否继续?',
    componentInfoMissing: '组件信息丢失',
    dailyProductionCapacityCanNotBeEmpty: '日产能不能为空',
    dailyProductionCapacityMustBeAPositiveInteger: '日产能必须是正整数',
    productNameRepeat: '产品型号重复',
    deviceInfoMissing: '设备信息丢失',
    addNewDeviceDelivery: '新建设备发货',
    shipmentNumberCanNotBeEmpty: '发货单号不能为空',
    deviceCanNotBeEmpty: '设备不能为空',
    thisActionWillDeleteThisDeviceDelivery: '此操作将删除该设备发货, 是否继续?',
    deviceDeliveryDetail: '设备发货详情',
    deviceDeliveryInfoMissing: '设备发货信息丢失',
    selectTheDeviceOrComponentFirst: '请先选择设备/组件',
    confirmInfo: '确认信息',
    numberCanNotBeEmpty: '数量不能为空',
    numberMustMoreThan0: '数量必须大于0',
    editDevice: '修改设备',
    editComponent: '修改组件',
    deviceInfo: '设备信息',
  },
};
